// Stub for front-end compilation only. Real data lives in the CX and is
// provided by build.py when building the embed-host.
export default {};
